import Axios from 'axios';
import axios from 'axios';

const API_BASE_URL = "https://api.viaq.ir/secret";


const axiosInstance = Axios.create({
    baseURL: API_BASE_URL, headers: {
        'Content-Type': 'application/json',
    }, timeout: 5000, timeoutErrorMessage: 5000,

});

axiosInstance.interceptors.request.use((req) => {
        const accessToken = localStorage.getItem("token");
        console.log("ACCESS TOKEN : ",accessToken);
        if (accessToken) {
            req.headers['x-auth-token'] = accessToken;

        }
      // console.log("REQUEST : ", req);

        return req;
    },
    (error) => {
        return Promise.reject(error);
    });


axiosInstance.interceptors.response.use((response) => {
  console.log("ON RESPONSE..........................")
  console.log("DATA : ", response.data);
    if (response.data.status.code !== 1) {
        throwCustomError(response.data.status.message, response.data.status.code)
    }


    return response.data;
}, async (error) => {

    const originalRequest = error.config;
    if (error.code === 'ECONNABORTED') {
      // console.log("Request timed out. Please try again.")
        throwCustomError("لطفا دوباره تلاش کنید", 44)

    }
    if (!error.response) {
        throwCustomError("خطای نامشخص سرور", 55)
    }
    if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
            const newAccessToken = await refreshToken();
            originalRequest.headers['x-auth-token'] = newAccessToken;
          // console.log("ORIGINAL REQUEST : ", originalRequest);
            return axiosInstance(originalRequest);
        } catch (refreshError) {
            throwCustomError("خطای نامشخص", 77)


        }
    } else {
        throwCustomError("دوباره تلاش کنید", 88)

    }

    return Promise.reject(error);
});


function throwCustomError(message, code) {
    const error = new Error(message);
    error.code = code;
    throw error;

}

async function refreshToken() {
    const refreshToken = localStorage.getItem("refreshToken");
    const token = localStorage.getItem("token");
    const response = await axios.post(
        `${API_BASE_URL}${"/dashboard/refresh-token"}`,
        {
            refreshToken: refreshToken,
        },
        {
            headers: {
                "x-auth-token": token,
            },
        }
    );


    if (response.status === 200 && response.data.status.code === 1) {
      // console.log("RESPONSE REFRESH TOKEN: ", response);
        localStorage.setItem("token", response.data.data.accessToken);
        localStorage.setItem("refreshToken", response.data.data.refreshToken);
        return response.data.data.accessToken;
    } else {

        // localStorage.removeItem("token");
        // localStorage.removeItem("refreshToken");

        const error = new Error("لطفا دوباره وارد شوید");
        error.code = 77;
        throw error;
    }

}

export default axiosInstance;
